"use client"

import { updateComment } from "@/lib/api/comments"
import AddOrEditCommentInput from "./AddOrEditCommentInput"
import { toast } from "sonner"
import { CommentResp } from "@types"
import { usePromiseRouter } from "@/app/hooks/usePromiseRouter"

export default function EditComment({
  comment,
  onSubmitStart,
  onSuccess,
}: {
  comment: CommentResp
  onSubmitStart?: () => void
  onSuccess?: () => void
}) {
  const router = usePromiseRouter()

  const onSubmit = async (newText: string) => {
    const promise = updateComment(comment.id, newText).then(() =>
      router.refresh()
    )

    toast.promise(promise, {
      loading: "Updating comment...",
      success: "Comment updated",
      error: "Failed to update comment",
    })

    await promise
  }

  return (
    <AddOrEditCommentInput
      placeholder="Edit your comment..."
      ctaText="Update"
      editExistingCommentText={comment.text}
      onSubmitStart={onSubmitStart}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
    />
  )
}
